// Per-domain primary brand color, stored in the Settings entity so each
// domain (orthocare.pt, orthocarerent.pt, orthocarerent.com, gestosageis.*)
// can have its own base color — mirroring how site images work.

export const DOMAIN_COLOR_KEYS = {
  'orthocare.pt': 'company_primary_color_orthocare_pt',
  'orthocarerent.pt': 'company_primary_color_orthocarerent_pt',
  'orthocarerent.com': 'company_primary_color_orthocarerent_com',
  'gestosageis.pt': 'company_primary_color_gestosageis',
  'gestosageis.com': 'company_primary_color_gestosageis',
  'gestosageis.store': 'company_primary_color_gestosageis',
};

export const DOMAIN_COLOR_DEFAULTS = {
  'orthocare.pt': '#0a3452',
  'orthocarerent.pt': '#0a3452',
  'orthocarerent.com': '#0a3452',
  'gestosageis.pt': '#0e6b4f',
  'gestosageis.com': '#0e6b4f',
  'gestosageis.store': '#0e6b4f',
};

// Domains exposed in the color picker UI (one card each).
export const DOMAIN_COLOR_CONFIGS = [
  { host: 'orthocare.pt', label: 'orthocare.pt', key: DOMAIN_COLOR_KEYS['orthocare.pt'], default: DOMAIN_COLOR_DEFAULTS['orthocare.pt'] },
  { host: 'orthocarerent.pt', label: 'orthocarerent.pt', key: DOMAIN_COLOR_KEYS['orthocarerent.pt'], default: DOMAIN_COLOR_DEFAULTS['orthocarerent.pt'] },
  { host: 'orthocarerent.com', label: 'orthocarerent.com', key: DOMAIN_COLOR_KEYS['orthocarerent.com'], default: DOMAIN_COLOR_DEFAULTS['orthocarerent.com'] },
  { host: 'gestosageis.pt', label: 'gestosageis.pt', key: DOMAIN_COLOR_KEYS['gestosageis.pt'], default: DOMAIN_COLOR_DEFAULTS['gestosageis.pt'] },
];

export const getCurrentDomain = () => (typeof window !== 'undefined' ? window.location.hostname : '');

// Resolve the primary color for a given host from Settings, falling back to
// the per-domain default, then the generic `company_primary_color`, then the
// platform default #076f77.
export const getPrimaryColorForDomain = (settings, host) => {
  const h = host || getCurrentDomain();
  const key = DOMAIN_COLOR_KEYS[h];
  if (key) {
    const found = Array.isArray(settings) ? settings.find((s) => s.setting_key === key) : null;
    if (found && found.setting_value) return found.setting_value;
    return DOMAIN_COLOR_DEFAULTS[h];
  }
  const generic = Array.isArray(settings) ? settings.find((s) => s.setting_key === 'company_primary_color') : null;
  return (generic && generic.setting_value) || '#076f77';
};